export default [
  {
    path: '/dsppartners',
    name: 'dashboard-dsppartners',
    component: () => import('@/views/dashboard/dsppartners/DspPartners.vue'),
  },
  {
    path: '/dsppartners/:id/edit',
    name: 'dashboard-dsppartner-edit',
    component: () => import('@/views/dashboard/dsppartners/Edit.vue'),
  },
  {
    path: '/dsppartners/create',
    name: 'dashboard-dsppartners-create',
    component: () => import('@/views/dashboard/dsppartners/Create.vue'),
  },
  {
    path: '/dsppartners/:id',
    name: 'dashboard-dsppartner',
    component: () => import('@/views/dashboard/dsppartners/DspPartner.vue'),
  },
  // DSP Partners Stats Routes
  {
    path: '/dsppartners/:id/stats',
    name: 'dashboard-dsppartner-stats',
    component: () => import('@/views/dashboard/dsppartners/stats/OverviewStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/sources',
    name: 'dashboard-dsppartner-stats-sources',
    component: () => import('@/views/dashboard/dsppartners/stats/SourceStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/sources/:sourceId',
    name: 'dashboard-dsppartner-stats-source-details',
    component: () => import('@/views/dashboard/dsppartners/stats/SourceDetails.vue'),
  },
  {
    path: '/dsppartners/:id/stats/campaigns',
    name: 'dashboard-dsppartner-stats-campaigns',
    component: () => import('@/views/dashboard/dsppartners/stats/CampaignStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/campaigns/:campaignId',
    name: 'dashboard-dsppartner-stats-campaign-details',
    component: () => import('@/views/dashboard/dsppartners/stats/CampaignDetails.vue'),
  },
  {
    path: '/dsppartners/:id/stats/rtb-partners',
    name: 'dashboard-dsppartner-stats-rtb-partners',
    component: () => import('@/views/dashboard/dsppartners/stats/RtbPartnerStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/rtb-partners/:rtbPartnerId',
    name: 'dashboard-dsppartner-stats-rtb-partner-details',
    component: () => import('@/views/dashboard/dsppartners/stats/RtbPartnerDetails.vue'),
  },
  {
    path: '/dsppartners/:id/logs',
    name: 'dashboard-dsppartner-logs',
    component: () => import('@/views/dashboard/dsppartners/Logs.vue'),
  },
  {
    path: '/dsppartners/:id/stats/country',
    name: 'dashboard-dsppartner-stats-country',
    component: () => import('@/views/dashboard/dsppartners/stats/GeoStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/country/:countryId',
    name: 'dashboard-dsppartner-stats-country-details',
    component: () => import('@/views/dashboard/dsppartners/stats/GeoDetails.vue'),
  },
  {
    path: '/dsppartners/:id/stats/city',
    name: 'dashboard-dsppartner-stats-city',
    component: () => import('@/views/dashboard/dsppartners/stats/GeoStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/city/:cityId',
    name: 'dashboard-dsppartner-stats-city-details',
    component: () => import('@/views/dashboard/dsppartners/stats/GeoDetails.vue'),
  },
  {
    path: '/dsppartners/:id/stats/device',
    name: 'dashboard-dsppartner-stats-device',
    component: () => import('@/views/dashboard/dsppartners/stats/DeviceOsStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/device/:deviceId',
    name: 'dashboard-dsppartner-stats-device-details',
    component: () => import('@/views/dashboard/dsppartners/stats/DeviceOsDetails.vue'),
  },
  {
    path: '/dsppartners/:id/stats/os',
    name: 'dashboard-dsppartner-stats-os',
    component: () => import('@/views/dashboard/dsppartners/stats/DeviceOsStats.vue'),
  },
  {
    path: '/dsppartners/:id/stats/os/:osId',
    name: 'dashboard-dsppartner-stats-os-details',
    component: () => import('@/views/dashboard/dsppartners/stats/DeviceOsDetails.vue'),
  },
]
